/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { OfferStatus } from 'types/enums/OfferStatus'
import { getOfferStatusByValue, getOfferStatusMap, getOfferStatusOptions, } from 'types/enums/OfferStatus.meta'

export const useOfferStatusOptions = () => {
    const { t } = useTranslation()

    const options = useMemo(() => getOfferStatusOptions(t), [t])
    const map = useMemo(() => getOfferStatusMap(t), [t])

    const getStatusDescriptor = (value: OfferStatus) => {
        return getOfferStatusByValue(value, t)
    }

    return {
        options,
        map,
        getStatusDescriptor,
    }
}
